<div *ngIf="!!menuConfiguration">
  <ng-container *ngIf="menuConfiguration.length > 1">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
      (menuOpened)="internalOnMenuOpened()"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu" (closed)="internalOnMenuClosed($event)">
      <ng-container *ngFor="let item of menuConfiguration">
        <button
          *ngIf="isMenuAction(item) && internalCheckVisible(item)"
          mat-menu-item
          [disabled]="internalCheckDisabled(item)"
          (click)="executeMenuAction(item)"
          [class]="item.actionClass"
        >
          <mat-icon [class]="item.iconClass"></mat-icon>
          <span>{{ item.label }}</span>
        </button>
        <mat-divider *ngIf="!isMenuAction(item)"></mat-divider>
      </ng-container>
    </mat-menu>
  </ng-container>
  <ng-container *ngIf="menuConfiguration.length == 1">
    <button
      *ngIf="isMenuAction(menuConfiguration[0]) && internalCheckVisible(menuConfiguration[0])"
      (click)="executeMenuAction(menuConfiguration[0])"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
      style="padding: 10px"
    >
      <div
        class="d-flex justify-content-center"
        [class]="menuConfiguration[0].actionClass"
      >
        <div>
          <mat-icon
            [class]="menuConfiguration[0].iconClass"
            style="margin-right: 10px; height: 100%"
          ></mat-icon>
        </div>
        <span>{{ menuConfiguration[0].label }}</span>
      </div>
    </button>
  </ng-container>
</div>
